var w = require('./src/wrapper');
exports.withWrapper = w.withWrapper;
exports.WrapperProvider = w.WrapperProvider;


//////////////////
// WEBPACK FOOTER
// ./node_modules/create-react-server/wrapper.js
// module id = 12
// module chunks = 0